// `avatar debate [file]` — discoverability + help only.
//
// debate-review is a Claude Code SLASH command (`/avatar:debate`), NOT a CLI action:
// the debate runs INSIDE a Claude session (Task subagents + PreToolUse guard + LLM),
// none of which the Node CLI can execute. This command exists so `avatar --help`
// lists it and points users to the correct way to run it.
import type { Command } from "commander";
import { chalk } from "../lib/terminal-logger.js";

export function registerDebateCommand(program: Command): void {
  program
    .command("debate [file]")
    .description("2-agent phản biện plan/doc — chạy trong Claude Code: /avatar:debate")
    .action((file?: string) => {
      const target = file ?? "<file>";
      process.stdout.write(
        `${chalk.cyan("💬")} ${chalk.bold("avatar debate")} là ${chalk.bold("slash command")} chạy TRONG Claude Code — không phải lệnh CLI.\n` +
          `   (debate cần Task subagent + hook + LLM, Node CLI không tự chạy được.)\n\n` +
          `   Cách dùng:\n` +
          `     1. ${chalk.gray("avatar sync")}                        # nhận pack mới nhất\n` +
          `     2. ${chalk.gray("avatar tools enable debate-review")}  # bật tool\n` +
          `     3. Mở Claude Code, gõ trong phiên:\n` +
          `        ${chalk.green(`/avatar:debate ${target} --plan`)}\n\n` +
          `   2 agent (Skeptic ⇄ Refiner) phản biện đóng khung trong artifact đến khi hết blocking;\n` +
          `   việc cần bạn quyết → ${chalk.bold("NEEDS_DECISION")} (tool không tự chốt thay bạn).\n`,
      );
      process.exit(0);
    });
}
